<template>
    <div class="padding_bottom_64" ref="content">
        <div class="menu_top padding_top_32">
            <div class="artical_contain display_flex  justify-content_flex-justify">
                <div class="artical_list_left">
                    <div class="artical_detail_title">{{articledetail.title}}</div>
                    <div class="artical_detail_editor">{{articledetail.author}}</div>
                    <!-- · {{formatTimefun(articledetail.publishTime)}} -->
                    <div v-html="articledetail.content" class="articlecontent"></div>
                </div>
                <div>
                    <div class="artical_hot">
                        <div class="artical_hot_title padding_bottom_30">{{$t('artical.maylove')}}</div>
                        <div class="artical_hot_box display_flex  justify-content_flex-justify" v-for="(item,index) in articledata" @click="toarticaldetail(item)">
                            <div class="artical_hot_Img"  :style="{backgroundImage: 'url(' + item.listImage + ')'}"></div>
                            <div class="artical_hot_right display_flex flex-direction_column justify-content_flex-justify">
                                <div class="artical_hot_subtitle">{{item.title}}</div>
                                <!-- <div class="artical_hot_date">{{formatTimefun(item.publishTime)}}</div> -->
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.position_relative{
    position: relative;
    
}
.padding-32 {
    padding: 32px 0;
}

.padding_top_32{
    padding-top: 32px;
}
.artical_contain{
    width:1218px;
    margin:0 auto;
    .articlecontent{

        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #51515C;
        line-height: 32px;
        text-align: left;
        img{
            max-width: 100%;
            height: auto;
            margin:10px 0;
        }
    }
    .artical_hot_title{
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #262633;
        line-height: 24px;
    }
    .padding_bottom_30{
        padding-bottom:30px;
        box-sizing:border-box;
    }

    .padding_bottom_24{
        padding-bottom:24px;
        box-sizing:border-box;
    }
    .artical_list{
        padding:18px 30px 18px 18px;
        background-color:#fff;
        
        cursor: pointer;
        &:hover{
            background-color:#F8FBFD;
        }
        .artical_list_img{
            width:282px;
            height:154px;
            background-color:#eee;
            display:inline-block;
            vertical-align:top;
            flex:1;
        }

        .artical_list_content{
            width:480px;
            height:154px;
            vertical-align:top;
            padding:0 0  0 25px;
            box-sizing:border-box;
           
            .title{
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #262633;
                line-height: 32px;
                margin-bottom:10px;
                box-sizing:border-box;
                @include linelimt(2);
            }
            .introduct{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #51515C;
                line-height: 24px;
                @include linelimt(2);
            }
            .content_bottom{
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #6EDCC7;
                line-height: 12px;
            }
            .content_bottom_L{
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 12px;
                display:inline-block;
                padding:6px 16px;
                box-sizing:border-box;
                background: linear-gradient(270deg, #28D877 0%, #0DC6B8 100%);
                border-radius: 0px 12px 12px 12px;
            }
            .content_bottom_R{
                display:inline-block;
                .date{
                    padding-left:6px;
                    box-sizing:border-box;
                    color:#888888
                }
            }
        }
    }
    
    .artical_hot{
        width: 384px;
        background: #fff;
        border: 1px solid #E9E9EB;
        padding:32px 24px 16px 32px;
        text-align: left;
        box-sizing:border-box;
        .artical_hot_title{
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #262633;
            line-height: 24px;
        }

        .artical_hot_box{
            margin-bottom:26px;
            box-sizing:border-box;
            cursor: pointer;
            .artical_hot_Img{
                width:141px;
                height:77px;
                // background-color:#eee;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center center;
            }

            .artical_hot_right{
                width:172px;
            }
            
            .artical_hot_subtitle{

                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #262633;
                line-height: 24px;
                @include linelimt(2)
            }
            .artical_hot_date{
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #888888;
                line-height: 12px;
            }
        }
    }

    .artical_hot_category{
        margin-top:24px;
        width: 384px;
        background: #fff;
        border: 1px solid #E9E9EB;
        padding:40px 24px 52px 32px;
        text-align: left;
        box-sizing:border-box;
        .artical_hot_title{

        }
    }

    .artical_list_left{
        width:810px;
        text-align:left;
    }
}

.artical_detail_title{
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 48px;
}
.artical_detail_editor{
    padding:24px 0;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    line-height: 12px;
}
</style>

<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
import {formatTime} from '@/utils/other.js'
import {getBannerApi,getarticledetailApi,collectApi,getarticlelistApi} from '@/api/api.js'
export default {
    name: '',
    components: {
        banner,
    },
    mixins: [myMixin],
    data() {
        return {
            articalcontent:"(香港，2019年10 月29日) 水中銀( 國際) 生物科技有限公司( 水中銀) 的小魚親測平台 (www.fishqc.com) 以全球獨家「轉基因鯖鱂魚」及「斑馬魚」胚胎毒性測試技術為市面28款暢銷面膜樣本進行毒性檢測。結果顯示，有18款產品被評為綠魚（品質卓越），6款產品為黃魚（品質合格），4款產品為紅魚（有待改善）。產品安全問題是社會關注的重點，水中銀同時亦回應消費者對產品功效的疑慮，因此推出以斑馬魚胚胎為綠魚標誌面膜樣本進行功效檢測。通過測量和計算面膜樣本對斑馬魚胚胎體內黑色素的抑制率，對產品的美白功效進行評估。結果顯示，於18款綠魚評級面膜樣本中，有12個樣本獲功效顯著評價，餘下6個樣本評為功效不顯著，接近7成暢銷面膜在美白功效檢測中功效顯著。分析指出，面膜的價錢差異頗大，樣本當中，片裝式面膜最高與最低價格相差16倍，而塗抹式面膜最高與最低價格可相差約10倍。<img src='https://w2.fishqc.net/image/cache/catalog/fangyi-pc-1920x424.png' style='width:100%' />",
            articledetail:{},
            collectflag:false,
            articledata:[]
            
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper1.$swiper
        },
        formatTimefun(){
            return function(ctime){
                return formatTime(ctime,'Y/M/D')
            }
        }
    },
    mounted() {
        // this.getbanner()
        this.getarticledetail()
        this.getarticlelist()
    },
    watch:{
        'articledetail':function(){    
            this.$nextTick(function(){
                //渲染完成
                var height = this.$refs.content.offsetHeight
                this.footerAuto(height)
            })
        },
        '$route' (to, from) {
            console.log(to)
            console.log(from)
            this.$router.go(0)
            //this.$forceUpdate()
        }
    },
    methods: {
       
        getarticledetail(){
            getarticledetailApi({
                cmsId:this.$route.params.id,
                lang:window.localStorage.getItem("LOCALE") ||  'chs'
            }).then(res => {
                console.log(res)
                if (res.code == 200) {
                    this.articledetail = res.data
                } else if(res.code == 400){
                    this.$router.push({
                        path: '/Page404'
                    })
                }else {
                    this.toast(res.message)

                }
            })
        },
       
        getarticlelist(){
            getarticlelistApi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                device:1,
                page:this.currentpage,
                limit:6
            }).then(res => {
                console.log(res)
                if (res.code == 200) {
                    this.articledata = res.data.list
                } else {
                    this.toast(res.message)

                }
            })
        },
        toarticaldetail(item){
            this.gorouter('/article/detail/'+item.cmsId)
        }

    }
}
</script>